import {Component, effect, OnInit, output, signal} from '@angular/core';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {Field, form, FormField, readonly, validateStandardSchema} from '@angular/forms/signals';
import {z} from 'zod';
import {InputText} from 'primeng/inputtext';
import {SelectField} from '../../../shared/components/select-field/select-field';
import {ZodAutoValidateDirective} from '../../../shared/decorators/auto-validate/auto-validate';
import {JsonPipe} from '@angular/common';
import {finalize} from 'rxjs';
import {AutoComplete, AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from 'primeng/autocomplete';

const userSchema = z.object({
  city: z.string().min(1, {message: 'Please select a city'}),
  country: z.string().min(1, {message: 'Please select a country'}),
  citizen_country: z.string().min(1, {message: 'Please select a country'}),
  residence_status: z.string().min(1, {message: 'Please select a status'}),
})

@Component({
  selector: 'app-residency-data',
  imports: [

    SelectField,
    ZodAutoValidateDirective,
    AutoComplete,
    FormField,
  ],
  templateUrl: './residency-data.html',
  styleUrl: './residency-data.css',
})
export class ResidencyData extends AppBaseComponent implements OnInit {
  saved = output();
  onBack = output();
  countries = signal([]);
  residenceStatus = signal([]);
  formModel = signal({
    city: '',
    country: '',
    citizen_country: '',
    residence_status: '',
  })
  form = form(this.formModel, (schema) => {
    readonly(schema.citizen_country, () => {
      return this.formModel().residence_status === 'citizen';
    });
    return validateStandardSchema(schema, userSchema);
  })
  filteredCities = signal<any[]>([]);

  ngOnInit(): void {
    this.http.get('country-list?list-version=1').subscribe((res: any) => this.countries.set(res));
    this.http.get('residence-status').subscribe((res: any) => this.residenceStatus.set(res));
  }

  constructor() {
    super();
    effect(() => {
      if (this.formModel().residence_status == 'citizen' && this.formModel().country !== this.formModel().citizen_country) {
        this.formModel.update((c) => ({
          ...c,
          citizen_country: c.country
        }))
      }
    });
  }

  submitForm($event: SubmitEvent) {
    $event.preventDefault();
    if (this.form().invalid()) {
      console.log(this.form().errors())
      return;
    }
    this.loading.set(true);
    this.http.post('user/update-profile', {...this.form().value()})
      .pipe(
        finalize(() => this.loading.set(false))
      )
      .subscribe(() => this.saved.emit());
  }

  filterCities($event: AutoCompleteCompleteEvent) {
    this.http.get('city-list?query=' + $event.query + '&&country=' + this.formModel().country)
      .subscribe((res: any) => this.filteredCities.set(res));
  }

  updateCity($event: AutoCompleteSelectEvent) {
    const cityValue = $event.value?.value || $event.value;
    this.formModel.update((c) => ({
      ...this.formModel(),
      city: String(cityValue),
    }))
  }
}
